export default __webpack_public_path__ + "static/media/vocabulary_list-new-2.5c67bf26.png";